<template>
  <el-form class="login-form" :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0" label-position="top" hide-required-asterisk>
    <el-form-item prop="username" label="账号">
      <el-input size="medium" @keyup.enter.native="handleLogin" v-model.trim="loginForm.username" auto-complete="off" placeholder="请输入帐号"></el-input>
    </el-form-item>
    <el-form-item prop="password" label="密码">
      <el-input size="medium" @keyup.enter.native="handleLogin" :type="passwordType" v-model.trim="loginForm.password" auto-complete="off" placeholder="请输入密码"></el-input>
    </el-form-item>
    <el-form-item v-if="show" prop="validCode" label="验证码">
      <div class="input-with-image">
        <el-input
          size="medium"
          @keyup.enter.native="handleLogin"
          v-model="loginForm.validCode"
          autocomplete="off"
          placeholder="请输入验证码"
        ></el-input>
        <el-image class="code" :src="imageUrl" @click="reImageCode"></el-image>
      </div>
    </el-form-item>
    <el-form-item class="login-button-item">
      <el-button class="login" @click="handleLogin()" :loading="loginLoading">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "pwdlogin",
  data() {
    return {
      show: true,
      loginForm: {
        username: "",
        validCode:'2406',
        password: "Ciic1234!"
      },
      imageUrl:'/api/image-code/code',
      loginLoading: false,
      loginRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 1, message: "密码长度最少为1位", trigger: "blur" }
        ],
        validCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '验证码长度为4位', trigger: 'blur' },
        ]
      },
      passwordType: "password"
    };
  },
  created() {
    this.reImageCode();
  },
  methods: {
    // 刷新验证码
    reImageCode(){
      let num =Math.floor(Math.random() * (10000 - 10 + 1)) + 10;
      this.imageUrl = "/api/image-code/code?num="+num;
      this.$forceUpdate();
    },
    showPassword() {
      this.passwordType === ''
        ? (this.passwordType = 'password')
        : (this.passwordType = '');
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          this.$store.dispatch("LoginByUsername", this.loginForm).then((res) => {
              if (res.data.data.success == "false") {
                this.loginLoading = false;
                this.show = true
                this.reImageCode()
                this.$message.error(res.data.data.msg);
              } else {
                this.$router.push({ path: "/index" });
                this.$message.success("登录成功");
              }
            }
          ).catch((error) => {
            this.loginLoading = false;
            this.show = true
            if (error.data && error.data.data.msg) {
              this.reImageCode()
              this.$message.error(error.data.data.msg);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.input-with-image {
  display: flex;
  align-items: center;
}

.el-input {
  flex: 1; /* 让输入框占据剩余空间 */
  margin-right: 10px; /* 可以根据需要调整输入框和验证码之间的间距 */
}
.code {
  width: 100px; /* 设置验证码图标的宽度 */
  height: 40px; /* 设置验证码图标的高度 */
  cursor: pointer; /* 添加手型光标，提醒用户该图标可点击 */
}
</style>
